import request from '@/utils/request'

let Order_taker_reviewApi = {

  /*接单员审核列表*/
  list(data) {
    return request._post('/shop/plus.order_taker_review.Index/index', data);
},
/*添加接单员审核*/
add(data) {
    return request._post('/shop/plus.order_taker_review.Index/add', data);
},
/*修改接单员审核*/
edit(data) {
    return request._post('/shop/plus.order_taker_review.Index/edit', data);
},
/*删除接单员审核*/
del(data) {
    return request._post('/shop/plus.order_taker_review.Index/del', data);
},
/*接单员审核详情*/
detail(data) {
  return request._post('/shop/plus.order_taker_review.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.order_taker_review.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.order_taker_review.Setting/getSetting', data, errorback);
    },
}
export default Order_taker_reviewApi;



// WEBPACK FOOTER //
// ./src/api/order_taker_review.js